import { get } from '../util/ajax';
export const fetchCycleBasedInfo = () => {
  return get('performance-info/cycles-based-info');
};
